import { useSelector } from "react-redux";
import store from "../stores/store";
import {
  getAllLayerIds,
  getLayerById,
  getLayerOpacity,
  getLayerVisibility,
  getLayerZIndex,
  setLayerOpacity,
  setLayerTimeDimension,
  setLayerVisibility,
  setLayerZIndex,
} from "../components/map/mapUtils";

const initialState = {
  layers: {},
  status: null,
  tree: [],
  storedLayers: {},
};

export default function swipeReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        return {
          layers: {},
          status: null,
          tree: [],
          storedLayers: {},
        };
      }
      break;

    case "swipe/layer/toggle":
      {
        let newState = { ...state };

        if (!newState.layers[action.payload.id]) {
          newState.layers[action.payload.id] = { ...action.payload };

          newState.tree.push({
            id: action.payload.id,
            title: action.payload.title,
            type: "layer",
            expanded: true,
            checked: true,
            layer: action.payload,
          });
        } else {
          let treeIndex = null;
          newState.tree?.forEach((layer, idx) => {
            if (layer.id === action.payload.id) {
              treeIndex = idx;
            }
          });

          if (treeIndex >= 0) {
            newState.tree.splice(treeIndex, 1);
          }

          delete newState.layers[action.payload.id];
        }

        return newState;
      }
      break;

    case "swipe/tree/update":
      {
        let newState = { ...state };

        newState.tree = action.payload;

        return newState;
      }

      break;

    case "layer/deleteById":
      {
        let newState = { ...state };

        delete newState.layers[action.payload];

        let availableDimensions = [];

        Object.keys(newState.layers).forEach((layerId) => {
          if (newState.layers[layerId]["visible"]) {
            availableDimensions = [
              ...availableDimensions,
              ...newState.layers[layerId].dimensions,
            ];
          }
        });

        newState.availableDimensions = availableDimensions
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });

        return newState;
      }
      break;

    case "swipe/layer/update": {
      let newState = { ...state };

      if (!newState.layers[action.payload.id][action.payload.property]) {
        newState.layers[action.payload.id][action.payload.property] = "";
      }
      newState.layers[action.payload.id][action.payload.property] =
        action.payload.value;

      return newState;
    }

    case "swipe/deactivate":
      {
        let newState = { ...state };

        newState.status = false;

        getAllLayerIds().forEach((el) => {
          let layer = newState.storedLayers[el];
          if (layer) {
            setLayerVisibility({ id: el }, layer.visibility);
            setLayerOpacity({ id: el }, layer.opacity);
            setLayerZIndex({ id: el }, layer.zIndex);
          }
        });

        return newState;
      }
      break;

    case "swipe/activate":
      {
        let newState = { ...state };

        getAllLayerIds().forEach((el) => {
          newState.storedLayers[el] = {
            opacity: getLayerOpacity({ id: el }),
            visibility: getLayerVisibility({ id: el }),
            zIndex: getLayerZIndex({ id: el }),
          };
        });

        getAllLayerIds().forEach((el) => {
          if (!newState.layers[el]) {
            setLayerVisibility({ id: el }, false);
          }
        });

        newState.status = true;

        return newState;
      }
      break;

    case "swipe/toggle":
      {
        let newState = { ...state };

        if (newState.status) {
          newState.status = false;

          getAllLayerIds().forEach((el) => {
            let layer = newState.storedLayers[el];
            if (layer) {
              setLayerVisibility({ id: el }, layer.visibility);
              setLayerOpacity({ id: el }, layer.opacity);
              setLayerZIndex({ id: el }, layer.zIndex);
            }
          });
        } else {
          getAllLayerIds().forEach((el) => {
            newState.storedLayers[el] = {
              opacity: getLayerOpacity({ id: el }),
              visibility: getLayerVisibility({ id: el }),
              zIndex: getLayerZIndex({ id: el }),
            };
          });

          getAllLayerIds().forEach((el) => {
            if (!newState.layers[el]) {
              setLayerVisibility({ id: el }, false);
            }
          });

          newState.status = true;
        }

        return newState;
      }
      break;

    default:
      return state;
  }
}
